import { Component, EventEmitter, Input, Output, AfterViewInit, OnDestroy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';

import { MyModal } from './../../common/my-modal/my-modal.component';
import { LoggerService } from './../../../services/logger.service';
import { ConfigHelper } from '../../../services/config.helper';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'audio-check',
    template: require('./audio-check.component.html')
})
export class AudioCheckComponent implements AfterViewInit, OnDestroy {
    @Output() audioCheckCompleted: EventEmitter<any> = new EventEmitter<any>();

    step: number = 1;
    currentProgress: number;
    infoBoxVisible: boolean;
    infoBoxText: string;
    infoBoxMode: string;
    iconCssClass: string;
    counterText: string;
    playbackSubscription: Subscription;
    audioCheckAudioClip: HTMLAudioElement;
    isWebDelivery: boolean;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private elementRef: ElementRef,
        private myModal: MyModal,
        private loggerService: LoggerService,
    ) {
        this.isWebDelivery = ConfigHelper.isTdpMode(true);
    }

    ngOnDestroy() {
        if (this.playbackSubscription) {
            this.playbackSubscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
        this.audioCheckAudioClip = this.createAudioElement("audio_check.mp3");
    }

    createAudioElement(src: string) {
        const elem = (this.elementRef.nativeElement as HTMLElement);
        const audioElem = document.createElement("audio");
        audioElem.autoplay = false;
        audioElem.controls = false;
        audioElem.autoplay = false;
        audioElem.src = `${ConfigHelper.getAudioAssetUrl()}/${src}`;
        elem.appendChild(audioElem);
        return audioElem;
    }

    playAudio = () => {
        this.step = 2;
        this.audioCheckAudioClip.play();
        this.currentProgress = 0;
        this.infoBoxVisible = true;
        this.infoBoxText = "Playing...";
        this.infoBoxMode = "ProgressBar";
        this.iconCssClass = 'play-icon';

        this.changeDetectorRef.markForCheck();

        const playbackTimeInSeconds = 16;

        this.playbackSubscription = Observable.interval(1000)
            .take(playbackTimeInSeconds + 1)
            .subscribe(x => {
                const timeElapsed = x + 1;
                this.currentProgress = this.setProgress(timeElapsed, playbackTimeInSeconds);
                this.changeDetectorRef.detectChanges();
            }, null, () => {
                this.step = 3;
                this.infoBoxVisible = false;
                this.changeDetectorRef.detectChanges();
            });
    }

    setProgress(current: number, totalTime: number): number {
        return (current / totalTime) * 100;
    }

    badRecording() {
        this.step = 4;
    }

    goodRecording() {
        this.audioCheckCompleted.emit("done");
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/audio-check/audio-check.component.ts